import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';
import { CTA } from '../components/Layout/CTA';

import '../components/GlobalStyle.css';

import EbikeSplash from '../assets/images/Ebike - Splash.png';

import Traffic from '../assets/icons/BPS Icon - Traffic.png';
import GraphIcon from '../assets/icons/BPS Icon - Graph.png';
import MovementIcon from '../assets/icons/BPS Icon - Movement.png';
import GoGreenIcon from '../assets/icons/BPS Icon - Go Green.png';

import { FadeLoad, FadeScroll, FadeLoadDelay } from '../components/styled/Motion.styled';
import { BPSTextLink } from '../components/styled/Buttons';
import { AssociationsCard, PointSalesCard, PostPurchaseCard } from '../components/EbikeComponents/EbikeCards';
import { EbikeAccordion } from '../components/EbikeComponents/EbikeAccordions';


const ImageMargin = styled.div`
    @media screen and (min-width: 1200px) {
        z-index: -1;
        width: 60%;
        margin: -8rem auto auto;
    }
`

const EbikeIncentives = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Programs | Ebike Incentives</title>
                <link rel="canonical" href="https://bestpayment.solutions/ebike-incentives" />
            </Helmet>
            <Navigation />
            <Container fluid>
                <Row className='pt-5 justify-content-evenly text-center'>
                    <Col lg={7}>
                        <FadeLoad>
                            <h1 className='fs-48'>
                                Implement an e-bike incentive program that gives consumers the ability to purchase with minimal out-of-pocket cash.
                            </h1>
                            <h3 className='py-4 color-steel fs-24'>
                                We bridge the gap between ideas and action for your e-bike incentive program
                            </h3>
                            <p>
                                From municipalities to bike shops to consumers, we work with your team to design, build, launch, and support your program. It's a win for you, your partners, and your customers. Our e-bike incentive program solutions include checks and 24-hour ACH payments, and more. This makes it easy for dealers to provide e-bike incentives, knowing that they will receive their payments quickly and easily.
                            </p>
                        </FadeLoad>
                    </Col>
                    <Col xs={12}>
                        <FadeLoadDelay>
                            <ImageMargin>
                                <img src={EbikeSplash} width='100%' />
                            </ImageMargin>
                        </FadeLoadDelay>
                    </Col>
                </Row>
            </Container >
            <Container fluid className='text-center py-5 bg-cream'>
                <FadeScroll>
                    <Row className="justify-content-center align-items-center pt-5">
                        <Col lg={6}>
                            <h3 className='fs-48'>Improving your community through e-bike incentives</h3>
                            <p>
                                E-bikes are a win not just for businesses, but for your community as a whole.
                            </p>
                        </Col>
                    </Row>
                </FadeScroll>
                <Row className="justify-content-evenly pt-3">
                    <Col xxl={2} md={5} sm={6} className='py-3'>
                        <img src={GoGreenIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Go green</h4>
                        <p>
                            E-bikes are a great option for making communities greener & healthier. <BPSTextLink href='https://www.calbike.org/e-bike-research-shows-environmental-and-economic-benefits/#:~:text=Not%20surprisingly%2C%20he%20found%20that,battery%20than%20an%20electric%20car.' target='_blank'>E-bikes produce up to 140 times less greenhouse gas than cars.</BPSTextLink>
                        </p>
                    </Col>
                    <Col xxl={2} md={5} sm={6} className='py-3'>
                        <img src={Traffic} width={60} />
                        <h4 className='fs-20 pt-4'>Tackle traffic</h4>
                        <p>
                            <BPSTextLink href='https://electrek.co/2022/10/31/scientific-study-shows-how-much-traffic-increases-when-e-bikes-and-e-scooters-are-banned/' target='_blank'>Studies have shown</BPSTextLink> that when e-bikes are adopted in a community, there is a decrease in both traffic congestion and commute times.
                        </p>
                    </Col>
                    <Col xxl={2} md={5} sm={6} className='py-3'>
                        <img src={MovementIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Motivate movement</h4>
                        <p>
                            E-bikes provide an efficient form of transportation and an accessible exercise option for people of all ages.
                        </p>
                    </Col>
                    <Col xxl={2} md={5} sm={6} className='py-3'>
                        <img src={GraphIcon} width={60} />
                        <h4 className='fs-20 pt-4'>Boost business</h4>
                        <p>
                            By incentivizing riders to purchase e-bikes at local bike shops, you provide them with a better, safer experience while also boosting the local economy.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5 circle-bg-2-fixed'>
                <Row className="justify-content-evenly align-items-center text-center py-5">
                    <Col xl={6}>
                        <h3 className='fs-48'>Reliable automated payments to bike shops, brands, and consumers</h3>
                        <p>
                            Let us be your lead out and set your incentive program up for success. Whether you are offering post-purchase or point-of-sale rebates, we make the payment process quick, easy, and reliable.
                        </p>
                    </Col>
                </Row>
                <Row className="justify-content-center pb-5">
                    <Col lg={5} md={6} sm={6}>
                        <PostPurchaseCard />
                    </Col>
                    <Col lg={5} md={6} sm={6}>
                        <PointSalesCard />
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-75 py-5 bg-cream'>
                <Row className="justify-content-evenly align-items-center">
                    <Col lg={5} md={4} className='py-5 py-md-0'>
                        <FadeScroll>
                            <h3 className='fs-48'>Powerful platform features to get your e-bike incentive program rolling</h3>
                        </FadeScroll>
                    </Col>
                    <Col lg={5}>
                        <EbikeAccordion />
                    </Col>
                </Row>
            </Container>
            <Container fluid className='text-center py-5'>
                <FadeScroll>
                    <Row className="justify-content-center align-items-center py-5">
                        <Col lg={6}>
                            <h3 className='fs-48'>Keep program management simple with our powerful suite of tools</h3>
                        </Col>
                    </Row>
                </FadeScroll>
                <Row className="justify-content-evenly pb-5">
                    <Col xxl={3} md={4} className='py-md-5 py-3'>
                        <h4>Instantly review the impact of your e-bike incentive program</h4>
                        <p>
                            We make it easy for you to quickly access your program’s data from your administrator dashboard. See real-time updates on pending claims, participant metrics, and program funds.
                        </p>
                    </Col>
                    <Col xxl={3} md={4} className='py-md-5 py-3'>
                        <h4>Easily reach out to participants</h4>
                        <p>
                            We make it simple for you to keep participants in the loop with email and text message communications. You can keep your participants updated on your program and their claims process.
                        </p>
                    </Col>
                    <Col xxl={3} md={4} className='py-md-5 py-3'>
                        <h4>Increase e-bike sales with referral rewards.</h4>
                        <p>
                            We make it simple for you to keep participants in the loop with email and text message communications. You can keep your participants updated on your program and their claims process.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5'>
                <Row className="justify-content-center align-items-center text-center text-md-start py-5">
                    <Col md={4}>
                        <h3 className='fs-48'>Our associations</h3>
                    </Col>
                    <Col md={6} className='py-5'>
                        <AssociationsCard />
                    </Col>
                </Row>
            </Container>
            <Container fluid className='bg-sky-tint-3 py-5'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default EbikeIncentives;